export default {
  sidebar: {
    tasks: 'Tareas',
    tickets: 'Tickets',
  },
};
